export default "__VITE_ASSET__DPfM7s_U__"